import React, {useState, useEffect} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Modal from "../../../components/ModalSuccessMessage";
import SideContainer from "../../../components/SideContainer/styles";
import SideForm from "../../../components/SideForm";
import Input from "../../../components/Input";
import Button from "../../../components/Button";

import { 
    Container,
    BankAccount,
    BankAccountContainer, 
    BankAccountContainerHeader, 
    BankAccountContainerHeaderTitle, 
    BankAccountContainerBody, 
    EditButton, 
    RadioButtonContainer, 
    RadioButtonContent, 
    DataContainer, 
    Title, 
    Info,
    Legend,
    Select,
    FormRadioButton,
    FormRadioButtonContainer,
    FormRadioButtonContent,
    InputWithHintContainer
} from "./styles";

import routes from "../../../routes/configuration.routes";
import Main from "../../../components/Main/index";
// import { paymentOptionsData } from "../../../data/provisionalData";

//Interface
import { PaymentOptionsDataInterface } from "./interfaces";

//Assets
import edit from "../../../assets/icons/edit.svg";
import bank from "../../../assets/icons/bankHover.svg";
import hint from "../../../assets/icons/hint.svg";
import api from "../../../service/api";

const PaymentOptions = () => {
    const [isAddFormVisible, setIsAddFormVisible] = useState(false);
    const [isEditFormVisible, setIsEditFormVisible] = useState(false);
    const [primaryAccount, setPrimaryAccount] = useState("0");
    const [typeAccount, setTypeAccount] = useState(0);

    const [paymentOptionsData, setPaymentOptionsData] = useState<Array<PaymentOptionsDataInterface>>([])

    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();

    useEffect(() => {
        if(login.user.groups.mc6a2 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    useEffect(() => {
        const getBankAccountAtApi = async () => {
            const {data} = await api.get("/branch/bank/account", {
                params: {
                    "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
                    "apiOwnerId": login.user.branchs.apiOwnerId
                }
            });

            setPaymentOptionsData(data.items)
        }

        getBankAccountAtApi()
    }, [])

    const handleClickToBecomeAccountPrimary = (id: string) => {
        setPrimaryAccount(id);
    }

    const openAddForm = () => {
        if(isEditFormVisible != true) {
            setIsAddFormVisible(true);
        }
    }

    const openEditForm = () => {
        if(isAddFormVisible != true) {
            setIsEditFormVisible(true);
        }
    }

    const bankAccountContainerGenerator = () => {
        if(paymentOptionsData !== undefined){
            return paymentOptionsData.map(paymentOption => {
                return (
                    <BankAccount key={paymentOption.id}>
    
                        <BankAccountContainer>
                            <BankAccountContainerHeader>
                                <div className="d-flex align-items-center">
                                    <BankAccountContainerHeaderTitle isPrimary={paymentOption.is_active}>
                                        {paymentOption.is_active ? "Conta Primária" : "Conta"}
                                    </BankAccountContainerHeaderTitle>
                                    {/* <EditButton onClick={() => openEditForm()}>
                                        <img src={edit} style={{marginRight: 4}}/>
                                        <span>Editar</span>
                                    </EditButton> */}
                                </div>
    
                                <RadioButtonContainer onClick={() => handleClickToBecomeAccountPrimary(paymentOption.id)}>
                                    <RadioButtonContent isPrimary={paymentOption.is_active}/>
                                </RadioButtonContainer>
                            </BankAccountContainerHeader>
    
                            <BankAccountContainerBody>
                                <div className="col-6" style={{padding: 0}}>
                                    <DataContainer>
                                        <Title>Banco</Title>
                                        <Info>{paymentOption.bank_name}</Info>
                                    </DataContainer>
    
                                    <div className="d-flex">
                                        <div className="col-6" style={{padding: 0}}>
                                            <DataContainer>
                                                <Title>Agência</Title>
                                                <Info>{paymentOption.routing_number}</Info>
                                            </DataContainer>
                                        </div>
    
                                        <div className="col-6" style={{padding: 0}}>
                                            <DataContainer>
                                                <Title>Dígito</Title>
                                                <Info>{paymentOption.routing_check_digit}</Info>
                                            </DataContainer>
                                        </div>
                                    </div>
    
                                    <DataContainer>
                                        <Title>Titular</Title>
                                        <Info>{paymentOption.holder_name}</Info>
                                    </DataContainer>
                                </div>
                                <div className="col-6">
                                    <DataContainer>
                                        <Title>Tipo de conta</Title>
                                        <Info>{paymentOption.type}</Info>
                                    </DataContainer>
    
                                    <DataContainer>
                                        <Title>Conta</Title>
                                        <Info>{paymentOption.account_number}</Info>
                                    </DataContainer>
    
                                    <DataContainer>
                                        <Title>CNPJ</Title>
                                        <Info>{paymentOption.taxpayer_id}</Info>
                                    </DataContainer>
                                </div>
                            </BankAccountContainerBody>
                        </BankAccountContainer>
                    </BankAccount>
                )
            })
        }
    }

    const openForm =  isAddFormVisible || isEditFormVisible;
    
    return(
        <div className="container-fluid ">

            <div className="row">
                <Modal text="Alterado com Sucesso"/>
                <Main 
                    isFormVisible={ openForm }
                    className={` ${openForm ? "col-d-none column-side-open" : "column-content"}`}
                >
                    <Header title="Configuração" subTitle="Altere as configurações gerais do sistema caso seja nescessário" subTitleWidth={271}/>
                    <NavTabs tabs={routes}/>

                    <Container isSideContainerVisible={ isAddFormVisible || isEditFormVisible }>
                        { bankAccountContainerGenerator() }
                    </Container>

                    {/* <div className="row">
                        <div className="col-12 col-lg-4">
                            <Button onClick={() => openAddForm()}>Adicionar conta</Button>
                        </div>
                    </div> */}
                </Main>

                {/* <SideContainer visible={isAddFormVisible} className="column-side">
                    <SideForm
                            title="Adicionar Conta"
                            icon={bank}
                            visible={() => setIsAddFormVisible(false)}
                    >
                        <form style={{ width: "100%", marginTop: 41 }}>
                            <fieldset>
                                <Legend>Selecione o tipo de conta</Legend>
                                <div className="d-flex mb-3">
                                    <FormRadioButtonContainer onClick={() => setTypeAccount(1)}>
                                        <FormRadioButton>
                                            <FormRadioButtonContent isPrimary={ typeAccount === 1 }/>
                                        </FormRadioButton>
                                        <span>Conta Corrente</span>
                                    </FormRadioButtonContainer>

                                    <FormRadioButtonContainer onClick={() => setTypeAccount(2)}>
                                        <FormRadioButton>
                                            <FormRadioButtonContent isPrimary={ typeAccount === 2 }/>
                                        </FormRadioButton>
                                        Conta Poupança
                                    </FormRadioButtonContainer>
                                </div>
                                <Select>
                                    <option>Selecione o Banco</option>
                                </Select>
                                <div className="row">
                                    <div className="col-8">
                                        <Input className="inputCustom" placeholder="Agência" />
                                    </div>
                                    <div className="col-4" style={{paddingLeft: 0}}>
                                        <Input className="inputCustom" placeholder="Dígito" />
                                    </div>
                                </div>
                                <Input className="inputCustom" placeholder="Conta" />
                                <Input className="inputCustom" placeholder="Nome do Titular" />
                                <InputWithHintContainer>
                                    <Input value="56.432.673/0001-19" disabled/>
                                    <img src={hint} style={{marginLeft: 3}}/>
                                </InputWithHintContainer>
                            </fieldset>
                        </form>
                        <Button
                            className="buttonCustom"
                            data-toggle="modal"
                            data-target="#exampleModal"
                        >
                            Adicionar
                        </Button>
                    </SideForm>
            </SideContainer> */}

            {/* <SideContainer visible={isEditFormVisible} className="column-side">
                <SideForm
                    title="Editar Cliente"
                    icon={bank}
                    visible={() => setIsEditFormVisible(false)}
                >
                    <form style={{ width: "100%", marginTop: 41 }}>
                        <fieldset>
                            <Legend>Selecione o tipo de conta</Legend>
                            <div className="d-flex mb-3">
                                <FormRadioButtonContainer onClick={() => setTypeAccount(1)}>
                                    <FormRadioButton>
                                        <FormRadioButtonContent isPrimary={ typeAccount === 1 }/>
                                    </FormRadioButton>
                                    <span>Conta Corrente</span>
                                </FormRadioButtonContainer>

                                <FormRadioButtonContainer onClick={() => setTypeAccount(2)}>
                                    <FormRadioButton>
                                        <FormRadioButtonContent isPrimary={ typeAccount === 2 }/>
                                    </FormRadioButton>
                                    Conta Poupança
                                </FormRadioButtonContainer>
                            </div>
                            <Select>
                                <option>Selecione o Banco</option>
                            </Select>
                            <div className="row">
                                <div className="col-8">
                                    <Input className="inputCustom" placeholder="Agência" />
                                </div>
                                <div className="col-4" style={{paddingLeft: 0}}>
                                    <Input className="inputCustom" placeholder="Dígito" />
                                </div>
                            </div>
                            <Input className="inputCustom" placeholder="Conta" />
                            <Input className="inputCustom" placeholder="Nome do Titular" />
                            <InputWithHintContainer>
                                <Input value="56.432.673/0001-19" disabled/>
                                <img src={hint} style={{marginLeft: 3}}/>
                            </InputWithHintContainer>
                        </fieldset>
                    </form>
                    <Button
                    className="buttonCustom"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    >
                        Editar
                    </Button>
                </SideForm>
            </SideContainer> */}
            </div>
        </div>
    )
}

export default PaymentOptions;